/* eslint no-param-reassign: "error" */
/* eslint-disable no-new */

// *******************************************************************************
// GLOBALS
// *******************************************************************************
axios.defaults.headers['Content-Type'] = 'multipart/form-data';

// *******************************************************************************
// 0.1 - BREAKPOINT VARS
// *******************************************************************************
const breakpointSm = 767;
const breakpointMd = 1023;
const breakpointLg = 1171;

// *******************************************************************************
// 0.2 - VARIOUS FUNCTIONS
// *******************************************************************************

// Return Window Width
function windowWidth() {
  return window.innerWidth || document.documentElement.clientWidth;
}

const isFractal = () =>
  !!document.querySelector('.Frame') ||
  window.location.href.includes('localhost:3010') ||
  window.location.href.includes('/preview/components/');

const isLocal = () => window.location.href.includes('localhost');

// *******************************************************************************
// 0.3 - FUNCTIONS
// *******************************************************************************

// Attach Events
function attachEvent(selector, event, handler) {
  document.addEventListener(
    event,
    (ev) => {
      let { target } = ev;
      for (; target && target !== document; target = target.parentNode) {
        if (target.matches(selector)) {
          try {
            handler.call(target, ev);
          } catch (e) {
            console.error(e);
          }
          break;
        }
      }
    },
    false,
  );
}

const euro = Intl.NumberFormat('sl-SI', {
  style: 'currency',
  currency: 'EUR',
  useGrouping: false,
});

// Animate
function animate(elementToAnimate, type) {
  switch (type) {
    case 'show':
      elementToAnimate.classList.add('is-visible');
      elementToAnimate.classList.remove('is-hidden');
      break;
    case 'hide':
      elementToAnimate.classList.add('is-hidden');
      elementToAnimate.classList.remove('is-visible');
      break;
    default:
      break;
  }
}

// Validate email input
const validateEmailInput = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

// *******************************************************************************
// 0.4 - DEBOUNCE FUNCTION
// *******************************************************************************

function debounce(func, wait, immediate) {
  let timeout;
  return function (...args) {
    const context = this;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

// *******************************************************************************
// 0.5 - SLIDE FUNCTIONS
// *******************************************************************************

const slideUp = (target, duration) => {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = `${duration}ms`;
  target.style.boxSizing = 'border-box';
  target.style.height = `${target.offsetHeight}px`;
  // eslint-disable-next-line no-unused-expressions
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(() => {
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

const slideDown = (target, duration, displayType) => {
  target.style.removeProperty('display');

  let { display } = window.getComputedStyle(target);

  if (display === 'none') {
    display = displayType;
  }
  target.style.display = display;

  target.style.display = display;
  const height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  // eslint-disable-next-line no-unused-expressions
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = `${duration}ms`;
  target.style.height = `${height}px`;
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout(() => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

const slideToggle = (target, duration, displayType) => {
  /* Slide-toggle logic */

  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration, displayType);
  }
  return slideUp(target, duration, displayType);
};

// *******************************************************************************
// 0.6 - Calculate Viewport units
// *******************************************************************************

// function calcVh() {
//   const vh = window.innerHeight * 0.01;
//   document.documentElement.style.setProperty('--vh', `${vh}px`);
// }

// const debounceCalcVh = debounce(() => {
//   calcVh();
// }, 50);

// // Only mobile has VH calculation
// window.addEventListener('DOMContentLoaded', () => {
//   calcVh();
// });

// // Only Calc VH for desktop, not mobile
// window.addEventListener('resize', () => {
//   if (
//     !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) &&
//     windowWidth() > breakpointSm
//   ) {
//     debounceCalcVh();
//   }
// });

// *******************************************************************************
// 0.7 - Smooth Scroll
// *******************************************************************************

const smoothScroll = new scrollToSmooth('a', {
  targetAttribute: 'data-scrollto',
  duration: 1000,
  durationRelative: false,
  durationMin: false,
  durationMax: false,
  easing: easeInOutCubic,
  onScrollStart: (data) => {
    // do something
    document.documentElement.style.scrollBehavior = 'initial';
  },
  onScrollUpdate: (data) => {
    // do something
  },
  onScrollEnd: (data) => {
    // do something
    document.documentElement.style.scrollBehavior = 'smooth';
  },
});
smoothScroll.init();

// function scrollToSmoothly(pos, time = 500) {
//   const currentPos = window.pageYOffset;
//   let start = null;

//   const step = (currentTime) => {
//     start = !start ? currentTime : start;
//     const progress = currentTime - start;
//     const positionUpY = currentPos - ((currentPos - pos) * progress) / time;
//     const positionDownY = ((pos - currentPos) * progress) / time + currentPos;

//     window.scrollTo(0, currentPos < pos ? positionDownY : positionUpY);

//     if (progress < time) {
//       window.requestAnimationFrame(step);
//     } else {
//       window.scrollTo(0, pos);
//     }
//   };

//   window.requestAnimationFrame(step);
// }

// *******************************************************************************
// 0.8 - Lazy loading (https://github.com/verlok/vanilla-lazyload)
// *******************************************************************************
// const lazyLoadInstance = new LazyLoad({
//   elements_selector: '.lazyload',
// });

// This can be called whenever you need to update the lazyload instance
// lazyLoadInstance.update();

// *******************************************************************************
// 0.9 - Match Height / Equal height : https://dev.to/dhruvangg/equal-height-in-vanilla-javascript-49ch
// *******************************************************************************

function setHeight(el, val) {
  if (typeof val === 'function') val = val();

  if (typeof val === 'string') el.style.height = val;
  else el.style.height = `${val}px`;
}

const equalheight = function (container) {
  let currentTallest = 0;
  let currentRowStart = 0;
  const rowDivs = new Array();
  let $el;
  const topPosition = 0;

  Array.from(document.querySelectorAll(container)).forEach((el, i) => {
    el.style.height = 'auto';
    const topPostion = el.offsetTop;
    if (currentRowStart !== topPostion) {
      let currentDiv = 0;

      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        setHeight(rowDivs[currentDiv], currentTallest);
      }
      rowDivs.length = 0;
      currentRowStart = topPostion;
      currentTallest = parseFloat(getComputedStyle(el, null).height.replace('px', ''));
      rowDivs.push(el);
    } else {
      rowDivs.push(el);
      currentTallest =
        currentTallest < parseFloat(getComputedStyle(el, null).height.replace('px', ''))
          ? parseFloat(getComputedStyle(el, null).height.replace('px', ''))
          : currentTallest;
    }

    let currentDiv = 0;
    for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
      setHeight(rowDivs[currentDiv], currentTallest);
    }
  });
};

window.addEventListener('load', () => {
  equalheight('.equal-height');
});
window.addEventListener('resize', () => {
  setTimeout(() => {
    equalheight('.equal-height');
  });
});

// *******************************************************************************
// 0.10 - ENVIRONMENT BADGE
// *******************************************************************************
const envBadge = document.querySelector('.sdt-env__badge');
if (envBadge) {
  envBadge.style.top = '150px';
  envBadge.addEventListener('mouseover', (ev) => {
    const { style } = ev.target;
    if (style.top) {
      style.removeProperty('top');
      style.bottom = '250px';
    } else {
      style.removeProperty('bottom');
      style.top = '150px';
    }
  });
}

// *******************************************************************************
// 0.11 - Get nonce for static pages
// *******************************************************************************
const getNonceForAction = async (formAction) => {
  if (isFractal()) {
    return Promise.resolve('');
  }

  try {
    const formDataNonce = {
      action: 'getNonceField',
      nonce_action: formAction,
    };

    const response = await axios.post(localData.apiURL, formDataNonce, {});
    return response.data.data.nonce;
  } catch (error) {
    console.error(error);
  }
};

// *******************************************************************************
// Form helper
// *******************************************************************************
const joinActiveItems = (checkedItems) =>
  Array.from(checkedItems)
    .map((checkedItem) => checkedItem.getAttribute('value'))
    .join(' | ');

const getFormValue = (form, fv) => {
  const formData = {};
  const requiredFormData = {};

  Object.keys(fv.getFields()).forEach((key) => {
    const element = form.querySelector(`[data-fv-name="${key.replace(/\[\]/g, '')}"]`);

    if (!element) {
      return;
    }

    const parentElem = element.closest('[data-input-group-parent]');

    if ((element.type === 'radio' || element.type === 'checkbox') && parentElem) {
      const selectedInputs = parentElem.querySelectorAll('input:checked');
      const itemValues = joinActiveItems(selectedInputs);
      formData[key] = itemValues || '';

      if (element.hasAttribute('required')) {
        requiredFormData[key] = itemValues || '';
      }
    } else {
      const elementValue = fv.getElementValue(key, element);
      formData[key] = elementValue;

      if (element.hasAttribute('required')) {
        requiredFormData[key] = elementValue;
      }
    }
  });

  return { inputs: JSON.stringify(formData), requiredInputs: JSON.stringify(requiredFormData) };
};

/**
 * @typedef {Object} AxiosOptions - Options object for Axios request.
 * @property {Object} headers - Request headers.
 * @property {string} headers.Content-Type - Content type for the request.
 * @property {string} [method] - HTTP method (e.g., GET, POST, PUT, etc.).
 * @property {string} [url] - Request URL.
 * @property {Object} [params] - URL parameters.
 * @property {Object} [data] - Request payload data.
 * @property {Object} [auth] - Authentication credentials (e.g., { username: 'user', password: 'pass' }).
 * @property {number} [timeout] - Request timeout in milliseconds.
 * @property {boolean} [withCredentials] - Indicates whether cross-site Access-Control requests
 *                                         should be made using credentials.
 */

/**
 * @typedef {Object} Options - Options object for the onFormSubmit function.
 * @property {AxiosOptions} [axiosOptions] - Options for the Axios request.
 * @property {Object} formData - The form data to submit.
 * @property {string} [recaptchaKey] - Recaptcha key.
 * @property {string} [recaptchaAction] - Recaptcha action.
 * @property {number} [timeout] - Timeout for the request in milliseconds.
 * @property {string} [url] - Url of the request.
 * @property {boolean} [forceError] - You should use this to force an form error, to test UI on error.
 */

/**
 * Simulates a form submission using Axios.
 * @param {Options} [options] - Additional options for the request.
 * @returns {Promise} - A promise that resolves to the Axios response.
 */

const onFormSubmit = async (options = { formData: {} }) => {
  // Default values
  if (!options.formData.lang) {
    options.formData.lang = localData.lang;
  }

  // FE / Preview submission of the form without API
  if (isFractal()) {
    console.warn('Fractal - Simulating request');
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (options.forceError) {
          reject(new Error('Simulated error'));
          return;
        }

        console.warn('Simulated success, FormData:', options.formData);
        resolve();
      }, options.timeout || 250);
    });
  }

  if (options.recaptchaKey && options.recaptchaAction) {
    const token = await grecaptcha.execute(options.recaptchaKey, { action: options.recaptchaAction });
    const nonce = await getNonceForAction(options.recaptchaAction);

    options.formData = { ...options.formData, action: options.recaptchaAction, nonce, token };
  }

  // Make a request to the API
  return axios.post(options.url || localData.siteURL, options.formData, {
    ...options.axiosOptions,
  });
};

// *******************************************************************************
// Add scrollbar width
// *******************************************************************************
let scrollbarSize = 0;
const getScrollbarWidth = () => {
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
  document.body.appendChild(outer);
  const inner = document.createElement('div');
  outer.appendChild(inner);
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  scrollbarSize = scrollbarWidth;
  outer.parentNode.removeChild(outer);
  document.documentElement.style.setProperty('--scroll-width', `${scrollbarWidth}px`);
};

getScrollbarWidth();

window.addEventListener('resize', debounce(getScrollbarWidth, 200));

// *******************************************************************************
// Toggle class functions
// *******************************************************************************
const toggleBodyScrollLock = (toggle) => {
  document.body.classList.toggle('body-scroll-locked', toggle);
};

const toggleActiveClass = (element, toggle) => {
  element.classList.toggle('is-active', toggle);
};

const removeActiveClass = (items) => {
  items.forEach((link) => {
    link.classList.remove('is-active');
  });
};

// *******************************************************************************
// Redirect page and smooth scroll
// *******************************************************************************
const siteHeader = document.querySelector('.site-header');
const getHeaderHeight = () => siteHeader?.offsetHeight || 0;

window.addEventListener('load', () => {
  const { hash } = window.location;

  if (!hash) {
    return;
  }

  const targetElement = document.querySelector(hash);

  if (!targetElement) {
    return;
  }

  const scrollPosition = targetElement.getBoundingClientRect().top + window.scrollY;
  setTimeout(() => {
    window.scrollTo({
      top: scrollPosition - getHeaderHeight(),
      behavior: 'smooth',
    });
  }, 300);
});

// *******************************************************************************
// Email validator
// *******************************************************************************

const getEmailError = (formElement) => {
  let emailMessage = '';
  if (formElement.querySelector('[type="email"]')) {
    emailMessage = formElement.querySelector('[type="email"]').getAttribute('data-fv-email-address___message');
  }
  return emailMessage;
};

const getEmailRegex = () => '^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$';

const validateEmail = (value) => {
  if (value === '') {
    return true;
  }

  const emailRegex = getEmailRegex();

  return (
    FormValidation.validators.emailAddress().validate({
      value,
    }).valid &&
    FormValidation.validators.regexp().validate({
      value,
      options: {
        regexp: emailRegex,
      },
    }).valid
  );
};

// *******************************************************************************
// Scroll function
// *******************************************************************************

const scrollTop = (element) => {
  const scrollPosition = element.getBoundingClientRect().top + window.scrollY;

  window.scrollTo({
    top: scrollPosition - getHeaderHeight(),
    behavior: 'smooth',
  });
};

// *******************************************************************************
// Tabs
// *******************************************************************************

const tabs = document.querySelectorAll('[data-tab]');
tabs.forEach((tab) => {
  const tabLinks = tab.querySelectorAll('[data-tab-link]');
  const tabContents = tab.querySelectorAll('[data-tab-content]');
  const tabImages = tab.querySelectorAll('[data-tab-image]');

  const closeTabContents = () => {
    [...tabLinks, ...tabContents, ...tabImages].forEach((elem) => {
      elem.classList.remove('is-active');
    });
  };

  tabLinks.forEach((link, index) => {
    link.addEventListener('click', () => {
      closeTabContents();
      const targetTabContent = tab.querySelectorAll('[data-tab-content]')[index];
      const targetTabImage = tab.querySelectorAll('[data-tab-image]')[index];
      link.classList.add('is-active');
      targetTabContent?.classList.add('is-active');
      targetTabImage?.classList.add('is-active');
    });
  });
});

// *******************************************************************************
// Lenis
// *******************************************************************************

const initSmoothScrolling = () => {
  const lenis = new Lenis({
    lerp: 0.2,
    smoothWheel: true,
  });

  lenis.on('scroll', ScrollTrigger.update);

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000); // Convert time from seconds to milliseconds
  });

  // Disable lag smoothing in GSAP to prevent any delay in scroll animations
  gsap.ticker.lagSmoothing(0);
};

if (windowWidth() > breakpointMd) {
  initSmoothScrolling();
}

// *******************************************************************************
// KeyDown Function
// *******************************************************************************

const onKeydown = (key, callback) => {
  document.addEventListener('keydown', (event) => {
    if (event.key.toLowerCase() === key.toLowerCase()) {
      callback(event);
    }
  });
};

// *******************************************************************************
// Stretch item until right of screen
// *******************************************************************************

const stretchToRightItems = document.querySelectorAll('.stretch-to-right');
const updateStretchedItemWidth = () => {
  stretchToRightItems.forEach((ele) => {
    const width = window.innerWidth - ele.getBoundingClientRect().left - scrollbarSize;
    ele.style.width = `${Math.floor(width)}px`;
  });
};

updateStretchedItemWidth();

window.addEventListener('resize', () => {
  updateStretchedItemWidth();
});

// Slider Lock Toggle Class
const swiperLockClass = (el, slider) => {
  const updateSwiperLockClass = () => {
    el.classList.toggle('is-lock', slider.isLocked);
  };

  updateSwiperLockClass();

  const updateSliderDebounce = debounce(() => {
    slider.update();
    updateSwiperLockClass();
  }, 200);

  window.addEventListener('resize', updateSliderDebounce);
};

// *******************************************************************************
// Fit Text
// *******************************************************************************

const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

const measureMaxLineWidth = (element) => {
  const words = element.textContent.trim().split(' ');

  // Temporarily replace content with span-wrapped words for width measurement
  element.innerHTML = words.map((word) => `<span style="display:inline-block">${word}&nbsp;</span>`).join('');

  const spans = element.querySelectorAll('span');
  const maxWidth = Array.from(spans).reduce((max, span) => Math.max(max, span.offsetWidth), 0);

  // Restore original content
  element.textContent = words.join(' ');

  return maxWidth;
};

const fitElementText = (element, options = {}) => {
  const container = element.parentElement;
  if (!container) return;

  const { minFontSize = 8, maxFontSize = 300, isMobile = windowWidth() <= breakpointSm } = options;

  // Start with the max font size
  element.style.fontSize = `${maxFontSize}px`;

  if (isMobile) {
    element.style.whiteSpace = 'normal';
    element.style.display = 'block';

    const maxLineWidth = measureMaxLineWidth(element);
    const scale = container.clientWidth / maxLineWidth;
    const newFontSize = clamp(maxFontSize * scale, minFontSize, maxFontSize);

    element.style.fontSize = `${newFontSize}px`;
  } else {
    element.style.whiteSpace = 'nowrap';
    element.style.display = 'inline-block';

    const scale = container.clientWidth / element.scrollWidth;
    const newFontSize = clamp(maxFontSize * scale, minFontSize, maxFontSize);

    element.style.fontSize = `${newFontSize}px`;
  }
};

const fitTextToContainer = () => {
  const elements = document.querySelectorAll('[data-fittext]');
  const isMobile = window.innerWidth <= 767;

  elements.forEach((el) => fitElementText(el, { isMobile }));
};

window.addEventListener('load', () => setTimeout(fitTextToContainer, 0));
window.addEventListener('resize', fitTextToContainer);

// *******************************************************************************
// "Edit mode" on front - scroll into view
// *******************************************************************************
document.addEventListener('DOMContentLoaded', () => {
  const editButton = document.getElementById('wp-admin-bar-add-edit-mode-on');
  if (!editButton) {
    return;
  }
  const checkbox = editButton.querySelector('input');
  editButton.addEventListener('click', (e) => {
    e.preventDefault();
    checkbox.checked = !checkbox.checked;
    if (!checkbox.checked) {
      e.target.blur();
    }
    editButton.classList.toggle('is-active', checkbox.checked);
    document.querySelectorAll('main section').forEach((section, index) => {
      section.classList.toggle('editable-section', checkbox.checked);
      section.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          if (checkbox.checked) {
            e.stopPropagation();
            window.location.replace(`/wp-admin/post.php?post=${localData.id}&action=edit&module-section=${index}`);
          }
        },
        { once: true },
      );
    });
  });

  const params = new URLSearchParams(window.location.search);
  const targetIndex = parseInt(params.get('module-section'), 10);
  if (!isNaN(targetIndex)) {
    const sections = document.querySelectorAll('main section');
    const index = targetIndex;
    if (sections[index]) {
      setTimeout(() => {
        sections[index].scrollIntoView({
          behavior: 'smooth',
        });
        params.delete('module-section');
        window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
      }, 500);
    }
  }
});

// *******************************************************************************
// Word splitting
// *******************************************************************************

Splitting();

// *******************************************************************************
// Active Indicator Movement
// *******************************************************************************

const updateActiveIndicator = () => {
  const activeIndicator = document.querySelectorAll('.active-indicator');

  activeIndicator.forEach((indicator) => {
    const wrapper = indicator.closest('[data-indicator-wrapper]');
    const slides = wrapper.querySelectorAll('[data-indicator-item]');

    const updateIndicatorForActiveSlide = () => {
      const activeSlide = wrapper.querySelector('.is-active');
      if (activeSlide) {
        const slideRect = activeSlide.getBoundingClientRect();
        const wrapperRect = wrapper.getBoundingClientRect();

        const offsetX = slideRect.left - wrapperRect.left;
        const offsetY = slideRect.top - wrapperRect.top;

        indicator.style.width = `${slideRect.width}px`;
        indicator.style.height = `${slideRect.height}px`;
        indicator.style.transform = `translateX(${offsetX}px) translateY(${offsetY}px)`;
      }
    };

    slides.forEach((slide) => {
      slide.addEventListener('click', () => {
        slides.forEach((ele) => ele.classList.remove('is-active'));
        slide.classList.add('is-active');

        updateIndicatorForActiveSlide();
      });

      const thumbSwiper = wrapper.closest('.swiper-thumbs');

      if (thumbSwiper) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'class') {
              const hasThumbActive = slide.classList.contains('swiper-slide-thumb-active');
              slide.classList.toggle('is-active', hasThumbActive);
              if (hasThumbActive) {
                updateIndicatorForActiveSlide();
              }
            }
          });
        });

        observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
      }
    });

    updateIndicatorForActiveSlide();
  });
};

window.addEventListener('DOMContentLoaded', () => {
  updateActiveIndicator();
});

// *******************************************************************************
// Update IOS BottomBar
// *******************************************************************************

const updateVisualViewportHeight = () => {
  const visualHeight = window.visualViewport?.height || window.innerHeight;
  document.body.style.setProperty('--visual-viewport-height', `${visualHeight}px`);
};

window.addEventListener('load', () => {
  setTimeout(updateVisualViewportHeight, 250);
});

// *******************************************************************************
// Responsive native scroll for swiper slider
// *******************************************************************************

const enableScrollbarSync = (parent, scrollbarEle) => {
  const swiperWrapper = parent.querySelector('.swiper');
  const swiperInner = parent.querySelector('.swiper-wrapper');
  const scrollbar = scrollbarEle || parent.querySelector('.swiper-scrollbar');

  if (!swiperWrapper || !swiperInner || !scrollbar) return;

  scrollbar.innerHTML = '<div class="swiper-scrollbar-thumb"></div>';
  const scrollbarThumb = scrollbar.querySelector('.swiper-scrollbar-thumb');

  let startX;
  let startThumbLeft;

  const onTouchMove = (event) => {
    const deltaX = event.touches[0].clientX - startX;
    const maxThumbMove = scrollbar.clientWidth - scrollbarThumb.clientWidth;
    const newLeft = Math.min(Math.max(startThumbLeft + deltaX, 0), maxThumbMove);

    const scrollPercentage = newLeft / maxThumbMove;

    swiperWrapper.scrollLeft = scrollPercentage * (swiperWrapper.scrollWidth - swiperWrapper.clientWidth);
  };

  const onTouchEnd = () => {
    document.removeEventListener('touchmove', onTouchMove);
    document.removeEventListener('touchend', onTouchEnd);
  };

  const onTouchStart = (event) => {
    startX = event.touches[0].clientX;
    startThumbLeft = scrollbarThumb.offsetLeft;

    document.addEventListener('touchmove', onTouchMove);
    document.addEventListener('touchend', onTouchEnd);
  };

  const syncThumbToScroll = () => {
    const maxThumbMove = scrollbar.clientWidth - scrollbarThumb.clientWidth;
    const maxScroll = swiperWrapper.scrollWidth - swiperWrapper.clientWidth;
    const percentage = swiperWrapper.scrollLeft / maxScroll;
    scrollbarThumb.style.left = `${percentage * maxThumbMove}px`;
  };

  scrollbarThumb.addEventListener('touchstart', onTouchStart);
  swiperWrapper.addEventListener('scroll', syncThumbToScroll);

  // Hide scrollbar if no overflow
  const slideCount = swiperInner.children.length;
  scrollbar.classList.toggle('hide', slideCount <= 1);

  // Cleanup function (call when switching back to desktop)
  // eslint-disable-next-line consistent-return
  return () => {
    scrollbarThumb.removeEventListener('touchstart', onTouchStart);
    swiperWrapper.removeEventListener('scroll', syncThumbToScroll);
  };
};

const setupResponsiveSliders = ({
  sliderElements,
  breakpoint = 767,
  initSlider,
  mobileFallback,
  parentSelector = '[data-slider-parent]',
  debounceDelay = 150,
}) => {
  const handleSlider = () => {
    sliderElements.forEach((sliderEl) => {
      const parent = sliderEl.closest(parentSelector);
      const isDesktop = windowWidth() > breakpoint;

      if (isDesktop) {
        if (!sliderEl.swiper) {
          initSlider(sliderEl);
          sliderEl.swiper.update();
        }
      } else {
        mobileFallback(parent);

        if (sliderEl.swiper) {
          sliderEl.swiper.destroy(true, true);
          sliderEl.swiper = null;
        }
      }
    });
  };

  // Initial run
  handleSlider();

  // Debounced resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleSlider, debounceDelay);
  });
};
